import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncSolarIconLinear = createAsyncIcon(() => import('./SolarIconLinear'));

export default AsyncSolarIconLinear;

AsyncSolarIconLinear.displayName = 'AsyncSolarIconLinear';
